import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.restrict.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.restrict.bind(this))
  }

  restrict() {
    const input = this.element
    const pos = input.selectionStart
    const digits = input.value.replace(/\D/g, "").slice(0, 10)
    if (digits !== input.value) {
      input.value = digits
      input.setSelectionRange(Math.min(pos, digits.length), Math.min(pos, digits.length))
    }
  }
}
